// Centralized Configuration
// Change only .env file - all files will auto-update

const config = {
    // API Base URL (from environment variable)
    API_BASE_URL: process.env.REACT_APP_API_URL || 'https://schatbot.whdevs.com',

    // WebSocket URL (same as API)
    SOCKET_URL: process.env.REACT_APP_API_URL || 'https://schatbot.whdevs.com',
};

export default config;
